// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1UuXwiFbWdWRbaOrUyv9f7","hidden":"JOFebQP49aW0Ai0waoHPq","closeAction":"_1I3mmszmqXNVb-lID1GX-s","contentContainer":"_3ZSKYuUDAmO55MCncr6nuq","content":"_3DZO9U29bpEyiej7i8CO3q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationBar/NotificationBar.css
// module id = 498
// module chunks = 8